import { AxiosPromise } from 'axios';

import { AxiosVue } from '@/AxiosVue';
import { ServicioProxy } from '@/config/enums';
import store from '@/store';

type getDashboardHtttpResponseBody = any;

const axios: AxiosVue = new AxiosVue(ServicioProxy.Metabase);
const routePatent: string = 'camaras/getPatentCameras';
const routeHistoricCamera: string = 'camaras/getHistoricCameras';

export type MsResponseData = {
  CODIGO_RESPUESTA: string;
  MENSAJE_RESPUESTA: string;
  data: any[];
};

const makeHttpRequest = (
  body: any,
  path: string
): AxiosPromise<getDashboardHtttpResponseBody> => {
  body.app = 'camaras';
  body.userid = store.state.user.id;
  return axios.http.post(`Metabase/PostgenericA/camaras/` + path, body);
};

const makeHttpRequestNormalized = (
  service: string,
  body: any
): AxiosPromise<MsResponseData> => {
  return axios.http.post(`Metabase/PostgenericA/camaras/` + service, body);
};

export const fetchCamaraModulo = (body: any, path: string) =>
  makeHttpRequest(body, path);

export const fetchCamaraHik = (body: any, path: string) =>
  makeHttpRequestNormalized(body, path);
